import React from 'react';

const Footer: React.FC = () => (
  <footer className="footer">
    <p className="footer-text">
      © Copyright 2026 |{' '}
      <a
        href="https://ecosystem.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
      >
        ecosystem.Ai
      </a>{' '}
      | All Rights Reserved |{' '}
      <a
        href="https://info.ecosystem.ai/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
      >
        Privacy Policy
      </a>{' '}
      |{' '}
      <a
        href="https://developer.ecosystem.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
      >
        Documentation
      </a>
    </p>
  </footer>
);

export default Footer;
